import { useState } from 'react';
import { useAcceptance } from '../../hooks/useAcceptance';

export function useSubscriptionTerms() {
  const [agree, setAgree] = useState(true);

  const { Modal, Trigger, isLoading, onAccept } = useAcceptance({
    typeAcceptance: 'offer_for_the_provision_of_paid_services',
  });

  return {
    CheckBox: () => (
      <>
        <div className="flex justify-start items-start gap-[12px] mt-3">
          {agree ? (
            <img
              className="w-[24px] cursor-pointer shrink-0"
              src="/icons/famicons_checkbox.svg"
              onClick={() => setAgree(false)}
            />
          ) : (
            <div
              className="w-[24px] h-[24px] cursor-pointer border border-white rounded-[4px] shrink-0"
              onClick={() => setAgree(true)}
            />
          )}

          <p className="font-raleway font-medium text-xs text-white text-justify">
            Я принимаю <Trigger /> и соглашаюсь с автоматическим списанием средств.
          </p>
        </div>

        <Modal />
      </>
    ),

    isChecked: agree,
    onAccept,
  };
}
